import api from "./api";

export function submitContactForm(data) {
  return api.post("/contactformentry", data);
}

export function submitSubscribe(data) {
  return api.post("/usersubscribe", data);
}
